



















































import {
  EnvioAutomaticoExecucao,
  EnviosAutomaticosTotalQualitativoService,
  FiltroEnviosAutomaticosTotalQualitativo,
} from "@/services/envios-automaticos-total-qualitativo.service";
import { GerarRelatorioClienteEnvioAutomaticoCommand, RelatorioService } from "@/services/relatorio.service";

import DataTable from "@/shared/components/data-table.vue";
import Tooltip from "@/shared/components/tooltip.vue";
import { dateFormatterSemHoras, dateHoraMinuto } from "@/shared/filters";
import { ServerPageOptions } from "@/shared/utils/datatable";
import { ehFalhaDeEnvio, StatusEnvioExecucao, statusEnvioExecucaoOpcoes } from "@/shared/enumeradores";
import moment from "moment";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  components: { DataTable, Tooltip, },
  filters: {
    dateFormatterSemHoras, dateHoraMinuto
  },
})

export default class TotalQualitativo extends Vue {
  filtro: FiltroEnviosAutomaticosTotalQualitativo = {
    idEnvioAutomatico: 0,
    statusEnvio: null,
    offset: "0",
    limit: "100",
    order: "",
    consultor: "",
    dataCriacao: "",
  }

  maxWidth = 15;
  loading = false;
  promise: Promise<EnvioAutomaticoExecucao[]> | null = null;
  statusEnvioOpcoes = statusEnvioExecucaoOpcoes;
  ehFalhaDeEnvio = (status: StatusEnvioExecucao) => ehFalhaDeEnvio(status);

  //Essas props são os parametros da url
  @Prop() readonly idEnvioAutomatico!: string;
  @Prop() readonly data!: string;

  get dataCriacaoFormatada(): string {
    if (!this.data) {
      return "";
    }
    return moment(this.data, "YYYY/MM/DD HH:mm:ss").format("YYYY-MM-DD");
  }

  headers = [
    { value: "consultor.idConsultor", text: "Id Consultor", width: "10%", withAliasValue: "ex.idConsultor" },
    { value: "consultor.nome", text: "Nome", width: "25%", withAliasValue: "c.Nome" },
    { value: "status", text: "Status do Envio", align: 'left', width: "10%", sortable: false },
    { value: "motivo", text: "Motivo", width: "35%", sortable: false },
    { value: "dataCriacao", text: "Enfileirada em", align: "center", width: "10%", withAliasValue: "ex.DataCriacao" },
    { value: "dataEnvioFila", text: "Hora do Envio", align: "center", width: "10%", sortable: false },
  ];

  @Watch("idEnvioAutomatico", { immediate: true })
  @Watch("data")
  onPropsChange() {
    this.fetchEnviosAutomaticosTotalQualitativo();
  }

  fetchEnviosAutomaticosTotalQualitativo(options?: ServerPageOptions) {
    if (options) {
      Object.assign(this.filtro, options);
    }

    const id = parseInt(this.idEnvioAutomatico, 10);
    this.filtro.idEnvioAutomatico = !isNaN(id) ? id : 0;

    if (this.data) {
      this.filtro.dataCriacao = this.data;
    }

    this.promise = EnviosAutomaticosTotalQualitativoService.listarEnviosAutomaticosTotalQualitativo(this.filtro);
  }

  public async gerarRelatorioClientesEnviosAutomaticos() {
    this.loading = true;
    const id = parseInt(this.idEnvioAutomatico, 10);
    try {
      const relatorioCommand: GerarRelatorioClienteEnvioAutomaticoCommand = {
        idEnvioAutomatico: id,
        dataExecucao: this.filtro.dataCriacao,
        consultor: this.filtro.consultor ?? "",
        statusEnvio: this.filtro.statusEnvio ?? null,
      };

      await RelatorioService.GerarRelatorioClientesEnviosAutomaticos(relatorioCommand);

    } catch (error) {
      console.error("Erro ao gerar e baixar o relatório:", error);
      alert("Ocorreu um erro ao gerar o relatório.");
    } finally {
      this.loading = false;
    }
  }
}

